import React from "react";
import { Link, Route } from "react-router-dom";
import Home from "./home/Home";
import ProductDetails from "./products/ProductDetails";
import OrderProduct from "./order/OrderProduct";
import logo from "../images/logo.png";
import ShoppingCart from "./shoppingcart/ShoppingCart";
import ShoppingCartQtyForm from "./shoppingcart/ShoppingCartQtyForm";

class Market extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shoppingCart: localStorage.getItem("shoppingCart")
        ? JSON.parse(localStorage.getItem("shoppingCart"))
        : null,
    };

    this.updateShoppingCart = this.updateShoppingCart.bind(this);
  }

  updateShoppingCart(cart) {
    this.setState({
      shoppingCart: cart,
    });
    localStorage.setItem("shoppingCart", JSON.stringify(cart));
  }

  render() {
    console.log(this.state);
    return (
      <div className="animated fadeIn">
        <div>
          <Route
            path="/market/product/"
            render={(props) => <ProductDetails {...props} />}
          />
          <Route
            path="/market/order/"
            render={(props) => <OrderProduct {...props} />}
          />
          <Route
            path="/market/cart/add/"
            render={(props) => (
              <ShoppingCartQtyForm
                {...props}
                updateShoppingCart={this.updateShoppingCart}
                shoppingCart={this.state.shoppingCart}
              />
            )}
          />
          <Route
            exact
            path="/market/cart/"
            render={(props) => (
              <ShoppingCart
                {...props}
                updateShoppingCart={this.updateShoppingCart}
                shoppingCart={this.state.shoppingCart}
              />
            )}
          />
        </div>
        <Home {...this.props} />
        <div>
          <div className="shopping-cart-btn">
            <Link to="/market/cart/">
              <img className="shopping-cart-img" src={logo} alt="" />
            </Link>
            {this.state.shoppingCart ? (
              <div>
                {this.state.shoppingCart.length > 0 ? (
                  <div className="cart-items-indicator is-round"></div>
                ) : (
                  <span></span>
                )}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Market;
